<template>
  <b-card id="smartTag" class="p-sm-4 m-sm-4 my-4">
    <h5 class="card-title pt-2">Smart Tag Settings</h5>
    <b-row>
      <b-col sm="5" md="4" lg="3">
        <b-form-group>
          <cool-label>
            Placement Type
            <span
              v-b-popover.hover.click.right="'Ad unit container type'"><span
              class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
          </cool-label>
          <b-form-select
            :options="containerTypeOptions"
            v-model="value.container.type"/>
        </b-form-group>
      </b-col>
      <b-col sm="5" md="4" lg="3" v-if="value.container.type && value.container.type.indexOf('DOCKED_') == -1">
        <b-form-group>
          <cool-label>
            Div Selector
            <span
              v-b-popover.hover.click.right="'CSS target content selector'"><span
              class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
          </cool-label>
          <b-form-input v-model="value.container.selector" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <cool-label>Closeable</cool-label>
          <span
            v-b-popover.hover.click.right="'Show close buttons for ad container to user'"><span
            class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
          <toggle-button
            v-model="value.container.closeable"
            :sync="true"
            color="var(--primary)">
          </toggle-button>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <cool-label>Lazy Load</cool-label>
          <span
            v-b-popover.hover.click.right="'Wait until container in view to render ad'"><span
            class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
          <toggle-button
            v-model="value.container.lazy_load"
            :sync="true"
            color="var(--primary)">
          </toggle-button>
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  export default {
    props: {
      value: { required: true }
    },
    data () {
      return {
        containerTypeOptions: [
          { value: 'SIMPLE', text: 'Standard In Place' },
          { value: 'OVERLAY', text: 'In-Image or Video Overlay' },
          { value: 'STICKY', text: 'Sticky push down' },
          { value: 'DOCKED_BOTTOM', text: 'Window Docked (Bottom)' },
          { value: 'DOCKED_RIGHT', text: 'Window Docked (Right)' },
          { value: 'DOCKED_BR', text: 'Window Docked (Bottom Right)' }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/PrebidRemoteContainer.vue